var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7542 6.58333H3.66667V5.41667H10.7542L9.85 4.5125L10.6667 3.66667L13 6L10.6667 8.33333L9.85 7.4875L10.7542 6.58333ZM7.75 4.25V1.91667H1.91667V10.0833H7.75V7.75H8.91667V10.0833C8.91667 10.4042 8.80243 10.6788 8.57396 10.9073C8.34549 11.1358 8.07083 11.25 7.75 11.25H1.91667C1.59583 11.25 1.32118 11.1358 1.09271 10.9073C0.864236 10.6788 0.75 10.4042 0.75 10.0833V1.91667C0.75 1.59583 0.864236 1.32118 1.09271 1.09271C1.32118 0.864236 1.59583 0.75 1.91667 0.75H7.75C8.07083 0.75 8.34549 0.864236 8.57396 1.09271C8.80243 1.32118 8.91667 1.59583 8.91667 1.91667V4.25H7.75Z",
    fill: "#000A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.ce5d4e67.svg";
export { ForwardRef as ReactComponent };